<template>
    <CommonDialog :value="value" :fullscreen="false" width="800" :title="$t('Preview')" show-action-toolbar @input="$emit('input', false)">
        <v-container>
            <v-row>
                <v-col>
                    <!--shortAnswer-->
                    <template v-if="questionTypeId == shortAnswer">
                        <v-text-field outlined dense filled :label="$t('ShortText')" />
                    </template>

                    <!--TextArea-->
                    <template v-if="questionTypeId == textArea">
                        <v-textarea filled rows="2" :label="textaera" value=""></v-textarea>
                    </template>
                    <!--Date-->
                    <template v-if="questionTypeId == date">
                        <v-menu ref="menu" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field outlined dense filled label="Date" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker no-title scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="menu = false">
                                    {{$t('Cancel')}}
                                </v-btn>
                                <v-btn text color="primary" @click="$refs.menu.save(date)">
                                    {{$t('Ok')}}
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </template>

                    <!--YesNo-->
                    <template v-if="questionTypeId == yesNo">
                        <v-switch :label="$t('YesNo')"></v-switch>
                    </template>

                    <!--number-->
                    <template v-if="questionTypeId == number">
                        <v-text-field type="number" outlined dense filled :label="$t('Number')" />
                    </template>

                    <!--dropdown-->
                    <template v-if="questionTypeId == dropdown || questionTypeId == trickyQuestion">
                        <v-select dense :label="$t('Select')" :items="ddlItems"></v-select>
                    </template>

                    <!--Radio Group-->
                    <template v-if="questionTypeId == multipleChoice">
                        <v-radio-group class="ma-0">
                            <v-radio dense hide-details v-for="n in 2" :key="'r'+ n" :label="`Radio ${n}`" :value="n"></v-radio>
                        </v-radio-group>
                    </template>

                    <!--Checkbox-->
                    <template v-if="questionTypeId == checkbox">
                        <v-checkbox dense label="Radio 1" value="one" hide-details></v-checkbox>
                        <v-checkbox dense label="Radio 2" value="two" hide-details></v-checkbox>
                    </template>

                    <!--rating-->
                    <template v-if="questionTypeId == rating">
                        <v-rating large></v-rating>
                    </template>

                    <!--Image-->
                    <template v-if="questionTypeId == image">
                        <v-row>
                            <v-col cols="12" sm="6" md="12" class="text-center">
                                <!-- Display the preview image next to the input file element -->
                                <img src="../../assets/images/الشعار الأول.jpg" class="preview-image" />
                            </v-col>
                        </v-row>

                    </template>

                    <!--VedioLink-->
                    <template v-if="questionTypeId == vedioLink">
                        <v-row>
                            <v-col cols="12" sm="6" md="12" class="text-center">
                                <!-- Display the preview image next to the input file element -->
                                <v-text-field type="text" outlined dense filled :label="$t('VedioLink')" disbaled />
                            </v-col>
                        </v-row>

                    </template>

                    <!--bipolarMatrix-->
                    <template v-if="questionTypeId == bipolarMatrix">
                        <v-row>
                            <v-col class="col-12">
                                <v-simple-table dense>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>
                                                    <span></span>
                                                </th>
                                                <th>
                                                    <span>1</span>
                                                </th>
                                                <th>
                                                    <span>2</span>
                                                </th>
                                                <th>
                                                    <span>3</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <span>الرجاء الاجابة عن السؤال 1؟</span>
                                                </td>
                                                <td><v-radio disabled></v-radio></td>
                                                <td><v-radio disabled></v-radio></td>
                                                <td><v-radio disabled></v-radio></td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span>الرجاء الاجابة عن السؤال 2؟</span>
                                                </td>
                                                <td><v-radio disabled></v-radio></td>
                                                <td><v-radio disabled></v-radio></td>
                                                <td><v-radio disabled></v-radio></td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span>الرجاء الاجابة عن السؤال 3؟</span>
                                                </td>
                                                <td><v-radio disabled></v-radio></td>
                                                <td><v-radio disabled></v-radio></td>
                                                <td><v-radio disabled></v-radio></td>
                                            </tr>
                                        </tbody>
                                    </template>

                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </template>

                </v-col>
            </v-row>
        </v-container>
    </CommonDialog>

</template>

<script>
    import { FormMethodEnum } from '@/helpers/constants/enumerations.js'
    import CommonDialog from '@/components/controls/CommonDialog'
    
    export default {
        components: {
            CommonDialog
        },
        props: {
            value: {
                type: Boolean,
                default: false
            },
            questionTypeId: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
                textEditor:FormMethodEnum.TextEditor,
                shortAnswer: FormMethodEnum.ShortAnswer,
                checkbox: FormMethodEnum.Checkboxes,
                multipleChoice: FormMethodEnum.MultipleChoice,
                dropdown: FormMethodEnum.Dropdown,
                trickyQuestion:FormMethodEnum.TrickyQuestion,
                rating: FormMethodEnum.Rating,
                number: FormMethodEnum.number,
                yesNo: FormMethodEnum.YesNo,
                date: FormMethodEnum.Date,
                textArea: FormMethodEnum.TextArea,
                bipolarMatrix: FormMethodEnum.BipolarMatrix,
                image: FormMethodEnum.Image,
                vedioLink: FormMethodEnum.VedioLink,
                ddlItems: ['one', 'two']
            }
        },
    }
</script>

<style scoped>
    .preview-image { width: 300px; /* Adjust the size as needed */ height: 300px; /* Adjust the size as needed */ }
</style>